import { render, staticRenderFns } from "./SkeletonCompTimeBenefitsAdvices.vue?vue&type=template&id=b8d17dd0&scoped=true"
import script from "./SkeletonCompTimeBenefitsAdvices.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonCompTimeBenefitsAdvices.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d17dd0",
  null
  
)

export default component.exports